const isNumber = (value: any) => {
  return (
    typeof +value === 'number' && Number.isFinite(value) && !Number.isNaN(value)
  );
};

export default isNumber;
